module.exports = __webpack_public_path__ + "static/img/Luke-Ryan.e0a4680.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke-Ryan.jpg
// module id = 5+fx
// module chunks = 0